module.exports = __webpack_public_path__ + "img/people-dress-simple.dd5fef7c.svg";